const messages = {
  en: {
    search: 'How can we help you?',
    noresults: 'No Results found for',
    results: 'results',
    clearAll: 'Clear All',
    type: 'Type',
    manufacturer: 'Manufacturer',
    model: 'Model',
    sortByRelevance: 'Most relevant',
  },
  'es-ud': {
    search: '¿Cómo podemos ayudarle?',
    noresults: 'No se han encontrado resultados para',
    results: 'resultados',
    clearAll: 'Limpiar todo',
    type: 'Tipo',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    sortByRelevance: 'Most relevant',
  },
  es: {
    search: '¿Cómo podemos ayudarle?',
    noresults: 'No se han encontrado resultados para',
    results: 'resultados',
    clearAll: 'Limpiar todo',
    type: 'Tipo',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    sortByRelevance: 'Most relevant',
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/containers/ESSearch/messages.js